import findAncestorWithAttr from '../Utils/findAncestorWithAttr';

export default class InsuranceAccordionHandler {
    constructor() {
        this.accordionSl = '[data-lf-accordion]';
        this.contentWrapperSl = '[data-lf-accordion-body]';

        this.activeAttr = 'data-lf-accordion-open';

        this.setupEventListeners(); 
    }

    setupEventListeners = () => {
        // Initialize tabindex for all closed accordions
        document.querySelectorAll(this.accordionSl).forEach((accordion) => {
            let container = accordion.parentNode.querySelector(this.contentWrapperSl);
            if (!accordion.parentNode.getAttribute(this.activeAttr)) {
                toggleTabFocus(container, false); // Disable tab focus for initially closed accordions
            }
        });

        document.addEventListener('click', (e) => {
            let accordion = e.target.matches(this.accordionSl)
                ? e.target
                : (e.target.parentNode && e.target.parentNode.matches
                    ? (e.target.parentNode.matches(this.accordionSl)
                        ? e.target.parentNode
                        : null)
                    : null);

            if (accordion) {
                let container = accordion.parentNode.querySelector(this.contentWrapperSl);
                let expandedHeight = container.scrollHeight * 2.0;

                if (!accordion.parentNode.getAttribute(this.activeAttr)) {
                    container.style.maxHeight = expandedHeight + 'px';

                    // Enable tab focus for focusable elements inside the accordion
                    toggleTabFocus(container, true);

                    // if clicked accordion is nested and has a parent accodion, the parent's max height needs to be adjusted 
                    let parentAccordion = findAncestorWithAttr(accordion.parentNode, this.activeAttr);
                    if (parentAccordion) {
                        let parentHeight = parentAccordion.querySelector(this.contentWrapperSl).style.maxHeight
                            .replace(/\D+$/g, '');

                        let parentAccordionBody = parentAccordion.querySelector(this.contentWrapperSl);
                        let newParentAccordionHeight = Number(parentHeight) + Number(expandedHeight);
                        parentAccordionBody.style.maxHeight = newParentAccordionHeight.toFixed(2) + 'px'; 
                    }

                } else {
                    container.style.maxHeight = 0;   

                    // Disable tab focus for focusable elements inside the accordion
                    toggleTabFocus(container, false);
                }

                if (accordion.parentNode.getAttribute(this.activeAttr)) {
                    accordion.parentNode.removeAttribute(this.activeAttr);
                } else {
                    accordion.parentNode.setAttribute(this.activeAttr, true);
                }
            }
        });
    }
}

// Helper function to toggle tab focus
const toggleTabFocus = (container, enable) => {
    const focusableSelectors = 'a, button, input, textarea, select, [tabindex]';
    const focusableElements = container.querySelectorAll(focusableSelectors);

    focusableElements.forEach((element) => {
        if (enable) {
            element.removeAttribute('tabindex'); // Restore default focus behavior
        } else {
            element.setAttribute('tabindex', '-1'); // Disable focus
        }
    });
};